import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { getRouteParam, setRouteParam, onRouteChange } from '../../hooks/useRouting';
function Tabs(props) {
    var _a, _b, _c, _d, _e, _f;
    const tabList = (_a = props.tabs) !== null && _a !== void 0 ? _a : React.Children.toArray(props.children)
        .filter((React.isValidElement))
        .map((child, i) => {
        var _a;
        return ({
            id: (_a = child.props.id) !== null && _a !== void 0 ? _a : i.toString(),
            label: child.props.label,
            content: child.props.children,
            icon: child.props.icon,
            badge: child.props.badge,
            default: !!child.props.default,
        });
    });
    const [activeTab, setActiveTab] = React.useState((_e = (_c = (_b = tabList.find(t => t.default)) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : (_d = tabList[0]) === null || _d === void 0 ? void 0 : _d.id) !== null && _e !== void 0 ? _e : '0');
    React.useEffect(() => {
        if (typeof window !== 'undefined') {
            const _onRouteChange = () => {
                if (props.hashKey) {
                    const param = getRouteParam(props.hashKey);
                    if (param && tabList.find((t) => t.id === param)) {
                        setActiveTab(param);
                    }
                }
            };
            const unregister = onRouteChange(_onRouteChange);
            _onRouteChange();
            return () => {
                unregister();
            };
        }
    }, [props.hashKey, tabList]);
    const handleTabClick = (id) => {
        if (typeof window !== 'undefined' && !!props.hashKey) {
            setRouteParam(props.hashKey, id);
        }
        else {
            setActiveTab(id);
        }
    };
    const isSide = props.position === 'side';
    return (_jsxs("div", { className: `${isSide ? 'row' : ''}`, children: [_jsx("div", { className: isSide ? 'col-md-2' : '', children: _jsx("ul", { className: `nav ${isSide ? 'flex-column nav-pills' : 'nav-tabs'}`, children: tabList.map((tab) => (_jsx("li", { className: "nav-item", children: _jsxs("button", { type: "button", className: `nav-link ${activeTab === tab.id ? 'active' : ''}`, onClick: () => !props.disabled && handleTabClick(tab.id), children: [tab.icon && _jsx("span", { className: !!tab.label || !!tab.badge ? 'me-1' : '', children: tab.icon }), tab.label, tab.badge && _jsx("span", { className: !!tab.label || !!tab.icon ? 'me-1' : '', children: tab.badge })] }) }, tab.id))) }) }), _jsx("div", { className: isSide ? 'col-md-9 mt-3 mt-md-0' : 'mt-3', children: (_f = tabList.find((tab) => tab.id === activeTab)) === null || _f === void 0 ? void 0 : _f.content })] }));
}
Tabs.Tab = function Tab(_) {
    return null;
};
export { Tabs };
